export const channelsConstants = {
    CHANNELS_FETCH: 'CHANNELS_FETCH',
    CHANNELS_SUCCESS: 'CHANNELS_SUCCESS',
    CHANNELS_ERROR: 'CHANNELS_ERROR',
    CHANNELS_UPDATE: 'CHANNELS_UPDATE',
    WHATSAPP_BUSINESS_PHONE_NUMBERS_FETCH: 'WHATSAPP_BUSINESS_PHONE_NUMBERS_FETCH',
    WHATSAPP_BUSINESS_PHONE_NUMBERS_SUCCESS: 'WHATSAPP_BUSINESS_PHONE_NUMBERS_SUCCESS',
    WHATSAPP_BUSINESS_PHONE_NUMBERS_ERROR: 'WHATSAPP_BUSINESS_PHONE_NUMBERS_ERROR',
    WHATSAPP_BUSINESS_TEMPLATES_SUCCESS: 'WHATSAPP_BUSINESS_TEMPLATES_SUCCESS',
    WHATSAPP_BUSINESS_TEMPLATES_ERROR: 'WHATSAPP_BUSINESS_TEMPLATES_ERROR',
};

export const CHANNEL = {
    SMS: 0,
    WHATSAPP: 1,
    EMAIL: 2,
    LIVE_CHAT: 4,
    FACEBOOK: 5,
    INSTAGRAM: 6,
    WHATSAPP_BUSINESS: 7,
    ARCHIVED: null,
};

export const CHANNEL_NAME = {
    SMS: 'SMS',
    WHATSAPP: 'WhatsApp (Beta)',
    EMAIL: 'Email',
    LIVE_CHAT: 'Live-chat',
    FACEBOOK: 'Facebook Messenger',
    INSTAGRAM: 'Instagram',
    WHATSAPP_BUSINESS: 'WhatsApp Business',
};

export const CHANNEL_MAP = {
    0: 'SMS',
    1: 'WhatsApp (Beta)',
    2: 'Email',
    4: 'Live-chat',
    5: 'Facebook Messenger',
    6: 'Instagram',
    7: 'WhatsApp Business',
};

export const CONNECT_WHATSAPP_BUSINESS_NUMBER_PARAM = 'connectWhatsAppBusinessNumber';
export const CONNECT_WHATSAPP_BUSINESS_ACCOUNT_PARAM = 'connectWhatsAppBusinessAccount';

export const WhatsAppHistoryImportStatus = {
    Running: 0,
    Completed: 1,
    Declined: 2,
    Failed: 3,
};

export const STATUS = {
    PENDING: 0,
    SUCCESS: 1,
    DISCONNECTED: 2,
    NUMBER_EXISTS: 3,
};

export const EMAIL_PROVIDER = {
    SMTP: 0,
    HOSTED: 1,
};

export const HOSTED_EMAIL_FORM = 'hostedEmail';

export const DEFAULT_RETURN_PATH_SUBDOMAIN = 'pm-bounces';

export const EMAIL_DOMAIN_STATUS = {
    PENDING: 0,
    VERIFIED: 1,
    FAILED: 2,
    SUSPENDED: 3,
};

export const isHostedEmailChannel = channel =>
    channel?.type === CHANNEL.EMAIL && channel?.emailParameters?.provider === EMAIL_PROVIDER.HOSTED;

export const SmsProviderType = {
    Twilio: 0,
    TurboSms: 1,
    Lifecell: 2,
    SmsTo: 3,
    Custom: 4,
    RingCentral: 5,
};
